import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletDescriptionCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletDescriptionCell: FC<GoodsReceiptPalletDescriptionCellProps> = ({ pallet }) => {
  const palletRow = pallet.goodsReceiptPalletRow

  return (
    <Box className='flex flex-col'>
      <Typography variant='body2'>{palletRow?.product?.companyProductDescription}</Typography>
      {(palletRow?.lots ?? []).map((lot) => (
        <Typography key={lot.goodsReceiptPalletRowLotId} variant='body2'>
          Lot/Batch: {lot.lotNumber} / {lot.batchNumber}
        </Typography>
      ))}
    </Box>
  )
}
